import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Interventions from './pages/Interventions';
import InterventionDashboard from './pages/InterventionDashboard';
import QRCodes from './pages/QRCodes';
import Documents from './pages/Documents';
import Vehicles from './pages/Vehicles';
import Residences from './pages/Residences';
import ResidenceForm from './pages/ResidenceForm';
import ResidenceDetails from './pages/ResidenceDetails';
import ResidenceTenants from './pages/ResidenceTenants';
import Users from './pages/Users';
import Settings from './pages/Settings';
import ScanQRCode from './pages/ScanQRCode';
import Tenants from './pages/Tenants';
import ReportsDashboard from './pages/ReportsDashboard';
import TenantPortal from './pages/TenantPortal';
import AuditLogs from './pages/AuditLogs';

const theme = createTheme({
  palette: {
    primary: {
      //main: '#2196f3',
      main: '#FF6B35',
    },
    secondary: {
      //main: '#f50057',
      main: '#004E89',
    },
  },
});

function App() {
  const token = localStorage.getItem('token');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/scan/:code" element={<ScanQRCode />} />
          <Route path="/tenant-portal" element={<TenantPortal />} />

          {token ? (
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="interventions" element={<Interventions />} />
              <Route path="interventions/dashboard" element={<InterventionDashboard />} />
              <Route path="qrcodes" element={<QRCodes />} />
              <Route path="documents" element={<Documents />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="residences" element={<Residences />} />
              <Route path="/residences/new" element={<ResidenceForm />} />
              <Route path="/residences/:id" element={<ResidenceDetails />} />
              <Route path="/residences/:id/edit" element={<ResidenceForm />} />
              <Route path="/residences/:id/tenants" element={<ResidenceTenants />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="reports" element={<ReportsDashboard />} />
              <Route path="users" element={<Users />} />
	      <Route path="audit-logs" element={<AuditLogs />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
